<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
type NewsletterForm = {
    email: string;
};

const { trackNewsletterRegistration } = useAnalytics();
const { pushSuccess, pushError } = useNotifications();
const { newsletterSubscribe } = useNewsletter();
const { t } = useI18n();
const isLoading = ref(false);

const handleNewsletterRegistration = (newsletterForm: NewsletterForm) => {
    isLoading.value = true;
    try {
        newsletterSubscribe({
            email: newsletterForm.email,
            option: 'subscribe',
        });

        trackNewsletterRegistration();
        pushSuccess(t('cms.element.form.newsletter.successSubscribe'));
    } catch (error) {
        pushError(t('cms.element.form.newsletter.errorSubscribe'));
    } finally {
        isLoading.value = false;
    }
};
</script>

<template>
    
<FormKitLazyProvider config-file="true">
<FormKit
        type="form"
        :submit-label="$t('account.register.submitLabel')"
        :actions="false"
        :classes="{
            form: 'lg:flex lg:mt-4 lg:gap-3',
        }"
        @submit="handleNewsletterRegistration"
    >
        <FormKit
            type="email"
            name="email"
            :placeholder="$t('global.footer.newsletter.email')"
            :validation="[['required'], ['email']]"
            :classes="{
                inner: 'rounded-3xl !border-transparent min-w-60',
                input: 'placeholder:!text-neutral-550 px-1 text-md font-normal',
                outer: 'my-4 lg:my-0',
            }"
        />

        <FormKit
            type="submit"
            :classes="{
                input: '!bg-transparent border border-neutral-800 text-neutral-800 text-sm w-max',
                outer: 'relative',
            }"
            :disabled="isLoading"
        >
            <template v-if="!isLoading"> Subscribe </template>

            <UtilityLoadingSpinner
                v-else
                size="small"
                loading-spinner-color="textColor"
            />
        </FormKit>
    </FormKit>
</FormKitLazyProvider>

</template>
